export default __webpack_public_path__ + "static/media/Ballroll_00092.c880b674.png";